export default __webpack_public_path__ + "static/media/five.8225ae0f.png";